import { FunctionComponent } from 'react';

import {
  FlexContainer,
  GridContainer,
  GridItem,
  MainContainer
} from '@astrumu/ui-library';

export const OverviewSkeleton: FunctionComponent = () => (
  <MainContainer>
    <GridContainer
      style={{
        animation: 'ga-opacity 1s steps(5, end) infinite',
        gap: 20,
        gridTemplateColumns:
          'minmax(min-content, 390px) minmax(min-content, 390px)',
        justifyContent: 'center',

        '@media (min-width: 768px)': {
          gap: '30px 40px'
        },

        '@media (min-width: 1024px)': {
          gap: '30px 75px'
        }
      }}
    >
      <GridItem
        style={theme => ({
          maxWidth: '30%',
          margin: 'auto',
          borderRadius: 5,
          width: '100%',
          height: 7,
          background: theme.contourColor,
          gridColumn: '1 / 3'
        })}
      />
      <FlexContainer style={{ gap: 10, flexDirection: 'column' }}>
        {[...Array(8)].map((_, index) => (
          <GridItem
            key={index}
            style={theme => ({
              animation: 'ga-opacity 1s steps(5, end) infinite',
              borderRadius: 5,
              width: '100%',
              height: 7,
              background: theme.contourColor
            })}
          />
        ))}
      </FlexContainer>
      <FlexContainer style={{ gap: 10, flexDirection: 'column' }}>
        {[...Array(8)].map((_, index) => (
          <GridItem
            key={index}
            style={theme => ({
              animation: 'ga-opacity 1s steps(5, end) infinite',
              borderRadius: 5,
              width: '100%',
              height: 7,
              background: theme.contourColor
            })}
          />
        ))}
      </FlexContainer>
    </GridContainer>
  </MainContainer>
);
